import angular from "angular";
import component from "./citizenships-control.component";

angular.module('citizenshipsControl', [component]);

export default 'citizenshipsControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/citizenships-control/citizenships-control.module.js